// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react' // eslint-disable-line @typescript-eslint/no-unused-vars
import ProgressCircle from '@uswitch/ev-components/lib/components/elements/progress-circle'
import { connect } from 'react-redux'
import { isQueryLoading } from '../../redux/elasticsearch/elasticsearch-selectors'

const LoadingState = (props) => {
  const { label, isLoading, children } = props
  return (
    <>
      <If condition={isLoading}>
        <div sx={{ position: 'relative' }}>
          <div
            sx={{
              textAlign: 'center',
              paddingTop: 'lg',
              paddingBottom: 'xxl',
              paddingX: 'xxl',
              backgroundColor: 'transparent',
              position: 'absolute',
              top: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              left: 0,
              right: 0,
              zIndex: 10,
            }}
          >
            <ProgressCircle />
            <h3 sx={{ paddingBottom: 'xxl' }}>{label}</h3>
          </div>
        </div>
      </If>

      <div
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          position: 'relative',
          opacity: isLoading ? '0.5' : '1',
        }}
      >
        {children}
      </div>
    </>
  )
}

export default connect((state, { label, children, datasetId }) => {
  const loading = isQueryLoading(state, datasetId)

  return {
    label,
    isLoading: loading,
    children,
  }
})(LoadingState)
